var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.896,
    height: 66.939,
    viewBox: "0 0 62.896 66.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1101.664 -648.262) rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1149.858,561a8,8,0,1,1-8-8,8,8,0,0,1,8,8",
    transform: "translate(-14.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1176.144,577.713a6.858,6.858,0,1,1-6.858-6.858,6.857,6.857,0,0,1,6.858,6.858",
    transform: "translate(-24.429 -6.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1181,608.713a5.714,5.714,0,1,1-5.715-5.713,5.714,5.714,0,0,1,5.715,5.713",
    transform: "translate(-27.001 -18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1164.43,636.143a4.572,4.572,0,1,1-4.573-4.572,4.571,4.571,0,0,1,4.573,4.572",
    transform: "translate(-21.857 -28.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1132.286,643.285a4.572,4.572,0,1,1-4.573-4.57,4.573,4.573,0,0,1,4.573,4.57",
    transform: "translate(-10.286 -30.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1105,624.286c0,4.57-6.858,4.57-6.858,0s6.858-4.572,6.858,0",
    transform: "translate(-1.285 -24.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1099.14,594.569a2.285,2.285,0,1,1-4.57,0,2.285,2.285,0,1,1,4.57,0",
    transform: "translate(0 -14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1117,569.569a2.286,2.286,0,0,1-4.573,0,2.286,2.286,0,0,1,4.573,0",
    transform: "translate(-6.428 -5.142)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadericon);
export default __webpack_public_path__ + "static/media/loader.icon.eb5cfe998791472abc56275665d1bb21.svg";
export { ForwardRef as ReactComponent };